import React, { useState } from "react";
import { ShieldCheck, HeartHandshake, Star } from "lucide-react";
import { insurancePlans } from "../mock";

const iconFor = (name) => {
  if (name === "Veterans") return Star;
  if (name === "DODD") return HeartHandshake;
  return ShieldCheck;
};

const PlanCard = ({ plan }) => {
  const [imgOk, setImgOk] = useState(!!plan.logo);
  const Icon = iconFor(plan.name);
  const logoUrl = plan.logo || null;

  return (
    <div className="card-hover bg-white rounded-2xl border border-slate-100 shadow-sm p-6 text-center flex flex-col items-center justify-center min-h-[150px]">
      {logoUrl && imgOk ? (
        <img
          src={logoUrl}
          alt={`${plan.full} logo`}
          className="h-12 max-w-[170px] object-contain mb-3"
          loading="lazy"
          onError={() => setImgOk(false)}
        />
      ) : (
        <div
          className="h-12 w-12 rounded-xl grid place-items-center mb-3"
          style={{ backgroundColor: `${plan.color}1a`, color: plan.color }}
        >
          <Icon className="h-6 w-6" />
        </div>
      )}
      <div className="font-display font-bold text-lg" style={{ color: plan.color }}>
        {plan.name}
      </div>
      <div className="text-xs text-slate-500 mt-1 leading-snug">{plan.full}</div>
    </div>
  );
};

const PlansAccepted = () => {
  return (
    <section className="section bg-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">
            Insurance & Programs Accepted
          </span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#0E2A33] mt-2">
            We work with Ohio's leading health plans
          </h2>
          <p className="text-slate-600 mt-4">
            Caregivers Alliance Homecare partners with MyCare Ohio and major managed-care
            plans so more Ohio families can access quality in-home care.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {insurancePlans.map((p) => (
            <PlanCard key={p.name} plan={p} />
          ))}
        </div>

        <p className="text-center text-sm text-slate-400 mt-8">
          Don't see your plan? Call us at{" "}
          <a href="tel:6145261548" className="text-[#0E5A72] font-medium">(614) 526-1548</a>{" "}
          — we'll help verify your coverage.
        </p>
      </div>
    </section>
  );
};

export default PlansAccepted;
